var _defs, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _line, _line2, _line3, _line4, _line5, _rect4, _path5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationsStep4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#556262;}.cls-2{fill:#dadede;}.cls-3{fill:#9da4a4;}.cls-4,.cls-7{fill:#5dd9c5;}.cls-5{fill:#18a795;}.cls-6{fill:#fff;}.cls-7{stroke:#9da4a4;stroke-linejoin:round;}.cls-8{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,20V53H9V20H63m0-1H9a1,1,0,0,0-1,1V53a1,1,0,0,0,1,1H63a1,1,0,0,0,1-1V20a1,1,0,0,0-1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.5,
    y: 22.5,
    width: 36,
    height: 28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,23V50H12V23H47m1-1H11V51H48V22Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 49.5,
    y: 22.5,
    width: 12,
    height: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61,23v5H50V23H61m1-1H49v7H62V22Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 49.5,
    y: 30.5,
    width: 12,
    height: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61,31V46H50V31H61m1-1H49V47H62V30Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 49.5,
    y1: 34.5,
    x2: 61.5,
    y2: 34.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 50,
    y1: 38.5,
    x2: 62,
    y2: 38.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 50,
    y1: 42.5,
    x2: 62,
    y2: 42.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 53.5,
    y1: 31,
    x2: 53.5,
    y2: 46
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 57.5,
    y1: 31,
    x2: 57.5,
    y2: 46
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.5,
    y: 30.5,
    width: 2,
    height: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44,31V46H43V31h1m1-1H42V47h3V30Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 52.5,
    y1: 25.5,
    x2: 58.5,
    y2: 25.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsStep4);
export default __webpack_public_path__ + "static/media/Illustrations_Step4.f0c99961d5b7168fe860963ce7ed369f.svg";
export { ForwardRef as ReactComponent };